<template>
  <div class="shared-link-restore-not-found">
    <div class="link-absent-container">
      <div class="link-absent-image"/>
      <div class="link-absent-text-block">
        <div class="el-text el-text--display-medium mt-24">
          {{ $t('shared-link.page-not-found.title') }}
        </div>
        <div
          class="el-text el-text--body-24 mt-16"
          style="color: #828489;">
          <div>{{ $t('shared-link.page-not-found.message.main') }}</div>
          <div>{{ $t('shared-link.page-not-found.message.description') }}</div>
          <div class="mt-16">{{ $t('shared-link.page-not-found.message.error') }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .shared-link-restore-not-found {
    position: absolute;
    top: 50%;
    left: 50%;
    margin-right: -50%;
    transform: translate(-50%, -50%);
  }

  .link-absent-container {
    margin-top: -78px;
    text-align: center;
  }

  .link-absent-image {
    display: inline-block;
    text-align: center;
    background: url('../assets/error/error.png') no-repeat;
    width: 128px;
    height: 128px;
  }

  .link-absent-text-block {
    text-align: center;
  }
</style>

<script>
export default {
  name: 'SharedLinkRestoreNotFound'
};
</script>
